"use client"
import { useState } from "react"
import AppSelect from "@/components/ui/app-select";

const ADD_NEW = "__add_new__"
const label = (v: string) => v.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())

interface CreatableSelectProps {
  value: string
  onChange: (value: string) => void
  /** Existing option values (snake_case). */
  options: string[]
  addLabel?: string
  placeholder?: string
  className?: string
  required?: boolean
}

/**
 * A dropdown that also lets the user add a value that isn't in the list. The typed value is
 * kept as entered; the API normalises it (snake_case) and it shows up in the list next time.
 */
export function CreatableSelect({
  value, onChange, options, addLabel = "Add new…", placeholder = "Type a new value", className = "", required,
}: CreatableSelectProps) {
  const known = options.includes(value)
  const [adding, setAdding] = useState(false)
  const custom = adding || (!!value && !known)

  return (
    <div>
      <AppSelect
        value={custom ? ADD_NEW : value}
        required={required && !custom}
        onChange={(e) => {
          if (e.target.value === ADD_NEW) {
            setAdding(true)
            onChange("")
          } else {
            setAdding(false)
            onChange(e.target.value)
          }
        }}
        className={className}
      >
        {options.map((o) => (
          <option key={o} value={o}>{label(o)}</option>
        ))}
        <option value={ADD_NEW}>＋ {addLabel}</option>
      </AppSelect>
      {custom && (
        <input
          type="text"
          value={value}
          required={required}
          autoFocus={adding}
          maxLength={60}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`${className} mt-2`}
        />
      )}
    </div>
  )
}
